import { FC } from 'react'
import * as styles from 'components/features/pfm/SidebarPopup/SidebarPopupFooter.styl'

export const SidebarPopupFooter: FC = (props) => {
  const { children } = props

  return (
    <footer className={ styles.footer }>{ children }</footer>
  )
}
